import { useEffect, useState } from "react";
import styles from "./learningPagination.module.scss";
import classNames from "classnames";
import LongArrowIcon from "@icons/longArrowIcon.svg";

export const LearningPagination = (props: Props) => {
  const LinkComponent = props.linkAs ?? "a";
  const { currentPage, perPage, total, nextText, previousText } = props;
  const lastPage = Math.ceil(total / perPage);
  const [url, setUrl] = useState("");

  useEffect(() => {
    setUrl(window.location.href);
  }, []);

  function getPageValue(page: number) {
    const urlObject = new URL(url, "https://dummy.link");
    if (page == 1) {
      urlObject.searchParams.delete("page");
    } else {
      urlObject.searchParams.set("page", page + "");
    }
    return urlObject.pathname + urlObject.search;
  }

  function printLeftLink() {
    if (currentPage <= 1) return <div className={styles["emptyBorder"]}></div>;

    return (
      <LinkComponent
        className={classNames(styles["prevNext"], styles["start"])}
        href={`${getPageValue(currentPage - 1)}`}
      >
        <span className={styles["arrowy"]}>
          <LongArrowIcon />
        </span>
        {previousText}
      </LinkComponent>
    );
  }

  function printFirstPage() {
    if (currentPage <= 3) return null;
    return (
      <LinkComponent href={`${getPageValue(1)}`} className={styles["numbery"]}>
        1
      </LinkComponent>
    );
  }

  function printLeftSideDots() {
    if (currentPage <= 4) return null;
    return <span className={styles["spany"]}>...</span>;
  }

  function printPages() {
    const pagesToPrint: number[] = [];

    for (let i = currentPage - 2; i <= currentPage + 2; i++) {
      if (i >= 1 && i <= lastPage) {
        pagesToPrint.push(i);
      }
    }

    return pagesToPrint.map((p, i) => {
      if (p == currentPage) {
        return (
          <span key={i} className={styles["selectedSpany"]}>
            {p}
          </span>
        );
      } else {
        return (
          <LinkComponent
            href={`${getPageValue(p)}`}
            key={i}
            className={styles["numbery"]}
          >
            {p}
          </LinkComponent>
        );
      }
    });
  }

  function printRightSideDots() {
    if (currentPage >= lastPage - 3) return null;
    return <span className={styles["spany"]}>...</span>;
  }

  function printLastPage() {
    if (currentPage > lastPage - 3) return null;
    return (
      <LinkComponent
        className={styles["numbery"]}
        href={`${getPageValue(lastPage)}`}
      >
        {lastPage}
      </LinkComponent>
    );
  }

  function printRightLink() {
    if (currentPage >= lastPage)
      return <div className={styles["emptyBorder"]}></div>;
    return (
      <LinkComponent
        className={styles["prevNext"]}
        href={`${getPageValue(currentPage + 1)}`}
      >
        {nextText}
        <span className={styles["arrowy"]}>
          <LongArrowIcon className={styles["rightArrow"]} />
        </span>
      </LinkComponent>
    );
  }

  return (
    <div className={styles["wrapper"]}>
      {printLeftLink()}
      <div className={styles["pagesContainer"]}>
        {printFirstPage()}
        {printLeftSideDots()}
        {printPages()}
        {printRightSideDots()}
        {printLastPage()}
      </div>
      {printRightLink()}
    </div>
  );
};

interface Props {
  currentPage: number;
  perPage: number;
  total: number;
  nextText: string;
  previousText: string;
  lang: "tr" | "en";
  linkAs?: React.ElementType;
}
